import Badge from '../common/Badge';
import { fmt, todayStr } from '../../utils/formatters';

export default function DateGroupHeader({ date, dayTotal, type, dailyLimit }) {
  // Note: this compares each date group's total against *today's* effective
  // limit (weekday/weekend can differ per day) — a reasonable approximation
  // for a quick list view rather than looking up each day's own range.
  const limitMin = dailyLimit?.min ?? dailyLimit ?? 0;
  const isToday = date === todayStr();
  const metLimit = type === 'sale' && dayTotal >= limitMin * 0.97;

  return (
    <div className="date-strip">
      <div className="date-strip-left">
        {isToday && <span className="today-pill">Today</span>}
        <span className="date-label">
          {new Date(date + 'T12:00:00').toLocaleDateString('en-GB', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
        </span>
      </div>
      <div className="date-strip-right">
        {fmt(dayTotal)}
        {type === 'sale' && (
          <Badge variant={metLimit ? 'success' : 'warning'}>
            {metLimit ? '✓ Limit met' : `£${(limitMin - dayTotal).toFixed(0)} below limit`}
          </Badge>
        )}
      </div>
    </div>
  );
}
